export const isNil = (value: string | number | boolean | null | undefined): boolean => {
	return value === null || value === undefined;
};
